import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../components/LoginPage.vue';
import DashboardPage from '../components/DashboardPage.vue';
import TagList from '../components/TagList.vue';
import TagList_old from '../components/TagList_old.vue';
import GatewayList from '../components/GatewayList.vue';
import AssetList from '../components/AssetList.vue';
import AssetPage from '../components/AssetPage.vue';
import EditAssetPage from '../components/EditAssetPage.vue';
import EditGatewayList from '../components/EditGatewayList.vue';
import EventTagSidebar from '../components/EventTagSidebar.vue';
import RegisterTag from '@/components/RegisterTag.vue';
import TagUpdatePost from '@/components/TagUpdatePost.vue';
import RegisterGateway from '@/components/RegisterGateway.vue';
import NotificationCenter from '@/components/NotificationCenter.vue';
import DashboardPage_KAVALAN from '@/components/DashboardPage_KAVALAN.vue';
import PieChart from '@/components/PieChart.vue';
import BarChart from '@/components/BarChart.vue';
import warningMap from '@/components/WarningMap.vue';
import LogisticMap from '@/components/LogisticMap.vue';
import AssetPage2 from '../components/AssetPage2.vue';
import EditAssetPage2 from '../components/EditAssetPage2.vue';
import WsServerUrlList from '../components/WsServerUrlList.vue';
import OtaServerUrlList from '../components/OtaServerUrlList.vue';
import GatewayCountrol2 from '@/components/GatewayCountrol2.vue';
import AssetMap2 from '@/components/AssetMap2.vue';
import Temperature from '@/components/Temperature.vue';
import AssetHitmap from '@/components/AssetHitmap.vue';
import CompanyMap from '@/components/CompanyMap.vue';
import DashboardSDAA from '@/components/DashboardSDAA.vue';
import DashboardOld from '@/components/DashboardOld.vue';
import DashboardSolum from '@/components/DashboardSolum.vue';
import DashboardDaeduck from '@/components/DashboardDaeduck.vue';
import DashboardSSH from '@/components/DashboardSSH.vue';
import DashboardHYU from '@/components/DashboardHYU.vue';
import RTHistory from '@/components/RTHistory.vue';
import TagRegisterPost from '@/components/TagRegisterPost.vue';
import { resolveTenant } from '../../../packages/tenant-config';

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    // 최초 로그인 시 비밀번호 변경 (users.must_change_password = 1 인 계정)
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/components/ChangePassword.vue'),
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: DashboardPage,
  },
  {
    path: '/dashboardOld',
    name: 'DashboardOld',
    component: DashboardOld,
  },
  {
    path: '/dashboard_KAVALAN',
    name: 'DashboardPage_KAVALAN',
    component: DashboardPage_KAVALAN,
  },
  {
    path: '/dashboardSolum',
    name: 'DashboardSolum',
    component: DashboardSolum,
  },
  {
    // FPT: SOLUM 기반 대시보드 재사용 (데이터는 로그인 회사=FPT 기준으로 조회)
    path: '/dashboardFPT',
    name: 'DashboardFPT',
    component: DashboardSolum,
  },
  {
    // INDIA: 인도향 PoC — SOLUM 기반 대시보드 재사용 (데이터는 로그인 회사=INDIA 기준)
    path: '/dashboardINDIA',
    name: 'DashboardINDIA',
    component: DashboardSolum,
  },
  {
    // SALES: SKAIChips 영업팀 데모용 — SOLUM 기반 대시보드 재사용 (테넌트 프리셋 SALES)
    path: '/dashboardSALES',
    name: 'DashboardSALES',
    component: DashboardSolum,
  },
  {
    path: '/dashboardDaeduck',
    name: 'DashboardDaeduck',
    component: DashboardDaeduck,
  },
  {
    path: '/dashboardSSH',
    name: 'DashboardSSH',
    component: DashboardSSH,
  },
  {
    path: '/dashboardHYU',
    name: 'DashboardHYU',
    component: DashboardHYU,
  },
  {
    path: '/dashboard/edit/:tag_mac', // tag_mac을 동적으로 받아오기
    name: 'EventTagSidebar',
    component: EventTagSidebar,
  },
  {
    path: '/dashboard_KAVALAN/edit/:tag_mac', // tag_mac을 동적으로 받아오기
    name: 'EventTagSidebarKavalan',
    component: EventTagSidebar,
  },
  {
    path: '/tagList',
    name: 'TagList',
    component: TagList,
  },
  {
    path: '/oldTagList',
    name: 'TagList_old',
    component: TagList_old,
  },
  {
    path: '/gatewayList',
    name: 'GatewayList',
    component: GatewayList,
  },
  {
    path: '/assets',
    name: 'AssetPage',
    component: AssetPage,
  },
  {
    path: '/assetPage',
    name: 'AssetPageFiltered',
    component: AssetPage,
  },
  {
    path: '/assetList',
    name: 'AssetList',
    component: AssetList,
  },
  {
    path: '/assets/edit/:tag_mac', // tag_mac을 동적으로 받아오기
    name: 'EditAssetPage',
    component: EditAssetPage,
  },
  {
    path: '/registerTag',
    name: 'RegisterTag',
    component: RegisterTag,
  },
  {
    path: '/registerGateway',
    name: 'RegisterGateway',
    component: RegisterGateway,
  },
  {
    path: '/tagUpdatePost',
    name: 'TagUpdatePost',
    component: TagUpdatePost,
  },
  {
    path: '/dashboardSDAA',
    name: 'DashboardSDAA',
    component: DashboardSDAA,
  },
  {
    path: '/assetMap',
    name: 'AssetMap',
    component: () => {
      // 자산맵 방식은 테넌트 프리셋 assetMap 이 정한다
      const mode = resolveTenant(localStorage.getItem('company')).assetMap;
      if (mode === 'sdaa-static') return import('@/components/AssetMapSDAA.vue');
      if (mode === 'post') return import('@/components/AssetMapPost.vue');
      if (mode === 'uploaded') return import('@/components/AssetMapSolumPage.vue');
      return import('@/components/AssetMap.vue');
    },
  },
  {
    path: '/gateways/edit/:gw_mac', // gw_mac을 동적으로 받아오기
    name: 'EditGatewayList',
    component: EditGatewayList,
  },
  {
    path: '/notificationCenter',
    name: 'NotificationCenter',
    component: NotificationCenter,
  },
  {
    path: '/pieChart', // PieChart 라우트 추가
    name: 'PieChart',
    component: PieChart,
  },
  {
    path: '/barChart', // PieChart 라우트 추가
    name: 'BarChart',
    component: BarChart,
  },
  {
    path: '/warningMap', // PieChart 라우트 추가
    name: 'warningMap',
    component: warningMap,
  },
  {
    path: '/logisticMap', // PieChart 라우트 추가
    name: 'LogisticMap',
    component: LogisticMap,
  },
  {
    path: '/assets2',
    name: 'AssetPage2',
    component: AssetPage2, //test용
  },
  {
    path: '/editAsset2',
    name: 'EditAssetPage2',
    component: EditAssetPage2, //test용
  },
  {
    path: '/wsServerUrlList',
    name: 'WsServerUrlList',
    component: WsServerUrlList,
  },
  {
    path: '/otaServerUrlList',
    name: 'OtaServerUrlList',
    component: OtaServerUrlList,
  },
  {
    path: '/gatewayControl',
    name: 'GatewayControl2',
    component: GatewayCountrol2,
  },
  {
    path: '/assetMap2',
    name: 'AssetMap2',
    component: AssetMap2,
  },
  {
    path: '/temperature',
    name: 'Temperature',
    component: Temperature,
  },
  {
    path: '/assetHitmap',
    name: 'AssetHitmap',
    component: AssetHitmap,
  },
  {
    path: '/companyMap',
    name: 'CompanyMap',
    component: CompanyMap,
  },
  {
    path: '/rtHistory',
    name: 'RTHistory',
    component: RTHistory
  },
  {
    path: '/tagRegisterPost',
    name: 'TagRegisterPost',
    component: TagRegisterPost
  },
  {
    path: '/zone-editor/:imageId',
    name: 'ZoneEditor',
    component: () => import('@/components/ZoneEditor.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// /dashboard 접근 시 전용 대시보드가 있는 테넌트는 그쪽으로 (homeRoute)
router.beforeEach((to, from, next) => {
  // 최초 로그인 비밀번호 변경이 끝나기 전에는 다른 화면으로 못 간다 (서버도 변경 API 외에는 403)
  const pwChangePending = localStorage.getItem('mustChangePassword') === '1' && !!localStorage.getItem('token');
  if (pwChangePending && to.path !== '/change-password' && to.path !== '/') {
    next('/change-password');
    return;
  }
  if (to.path === '/change-password' && !pwChangePending) {
    next(localStorage.getItem('token') ? '/dashboard' : '/');
    return;
  }
  if (to.path === '/dashboard') {
    const home = resolveTenant(localStorage.getItem('company')).homeRoute;
    if (home && home !== '/dashboard' && home.startsWith('/dashboard')) { next(home); return; }
  }
  next();
});

export default router;
